/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string, shape, object,  bool, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import {
    Button, CircularProgress,
} from '@material-ui/core';

const styles = (theme) => ({
    container: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        border: '1px solid',
        borderRadius: '10px',
        height: '125px',
        padding: theme.spacing(2),
        margin: '0 10px 40px 0',
        [theme.breakpoints.down(900)]: {
            justifyContent: 'center',
            height: '135px',
        },
    },
    buttonContainer: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down(900)]: {
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-evenly',
        },
    },
    imageContainer: {
        position: 'relative',
        [theme.breakpoints.down(900)]: {
            '& $giftImage': {
                display: 'none',
            },
        },
    },
    giftImage: {
        display: 'block',
    },
    imageWidth: {
        [theme.breakpoints.down(900)]: {
            width: '25%',
        },
    },
    coverImage: {
        width: '68px',
        height: '45px',
        position: 'absolute',
        top: '5px',
        left: '5%',
    },
    buttonWrapper: {
        display: 'flex',
    },
    button: {
        margin: '0 10px',
        color: theme.palette.common?.black,
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.secondary?.['200'],
        height: '30px',
        width: '75px',
    },
    typography: {
        fontWeight: 'bold',
        marginBottom: '5px',
        [theme.breakpoints.down(900)]: {
            margin: '0px',
        },
    },
    labelType: {
        fontSize: '0.875rem',
        margin: '0px',
        textAlign: 'center',
    },
    message: {
        fontSize: '0.875rem',
        margin: '0px',
        marginTop: '2px',
        [theme.breakpoints.down(480)]: {
            whiteSpace: 'nowrap',
            fontSize: '0.813',
        },
    },
    customWrapper: {
        minWidth: '80px',
        maxWidth: '60px',
        maxHeight: '57px',
        minHeight: '57px',
        borderRadius: '2px',
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    personalizeMessage: {
        width: '120px',
        margin: '5px 0',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down(900)]: {
            width: '75px',
            margin: '5px 0px 0px 0px',
        },
    },
    CircularProgress: {
        textAlign: 'center',
        margin: '0 auto',
    },
    loaderOverlay: {
        display: 'flex',
        zIndex: 9,
        position: 'absolute',
        background: 'rgba(255,255,255,.7)',
        top: '3px',
        textAlign: 'center',
        left: '3px',
        bottom: '3px',
        right: '3px',
        verticalAlign: 'middle',
        alignItems: 'center',
    },
});

const GCIPersonalizationV1 = ({
    classes,
    gciKey,
    gciData,
    loader,
    loading,
    featureFlags,
    placementText,
    cgcMessageData,
    messageData,
    editCGCLabelData,
    setModalState,
    removeGCIData,

}) => (
    <div className={classes.container}>
        {loader && <div className={classes.loaderOverlay}><CircularProgress className={classes.CircularProgress} /></div>}
        <div className={classes.buttonContainer}>
            {
                loading
                    ? (
                        <p className={classes.typography}>Loading...</p>
                    ) : (
                        <>
                            {
                                featureFlags['is-cgc-api-from-main-url'] || gciKey
                                    ? (
                                        <>
                                            {
                                                gciData?.key_id
                                                    ? (
                                                        <>
                                                            <p className={classes.typography}>Personalization has been added!</p>
                                                            <div className={classes.buttonWrapper}>
                                                                <Button data-testid="gci-button-remove" className={classes.button} color="primary" onClick={() => { removeGCIData(); }}>Remove</Button>
                                                                <Button data-testid="gci-button-edit" className={classes.button} color="primary" onClick={() => { editCGCLabelData(); }}>Edit</Button>
                                                            </div>
                                                        </>
                                                    )
                                                    : (
                                                        <>
                                                            <p className={classes.typography}>Personalize this Item? - Only {cgcMessageData?.price_message || '$5.00'}!</p>
                                                            <Button data-testid="gci-button-add" className={classes.button} color="primary" onClick={() => { setModalState(true); }}>Yes!</Button>
                                                        </>
                                                    )
                                            }
                                        </>
                                    )
                                    : (
                                        <p className={classes.typography}>Apologies, but we are unable to add personalization at this time.</p>
                                    )
                            }
                        </>
                    )
            }
        </div>
        <div className={`${classes.imageContainer} ${gciData?.key_id ? classes.imageWidth : ''}`}>
            {gciData?.key_id
                ? (
                    <>
                        <div className={classes.customWrapper} style={{ backgroundImage: `url(${featureFlags['is-cgc-api-from-main-url'] ? gciData.coverImage : gciData.thumbnail})` }}>
                            <p className={classes.labelType}>
                                {
                                    gciData.text
                                            && (
                                                (featureFlags['is-cgc-api-from-main-url'] && gciData.thumbnail)
                                                || (!featureFlags['is-cgc-api-from-main-url'] && gciData.coverImage)
                                            )
                                        ? 'Photo And Message'
                                        : `${gciData.text ? 'Your Message' : placementText}`
                                }
                            </p>
                        </div>
                        {
                            featureFlags['is-cgc-api-from-main-url']
                                ? (
                                    <>
                                        {gciData?.thumbnail && <img className={classes.coverImage} src={gciData?.thumbnail} alt="coverImage" />}
                                    </>
                                ) : (
                                    <>
                                        {gciData?.coverImage && <img className={classes.coverImage} src={gciData?.coverImage} alt="coverImage" />}
                                    </>
                                )
                        }
                        {gciData.text ? <p className={classes.personalizeMessage}>{gciData.text}</p> : ''}
                        <p className={classes.message}>Price: {cgcMessageData?.price_message || '$5.00'}!</p>
                    </>
                )
                : <img className={classes.giftImage} src={messageData?.image?.url || 'https://cdn1.thepopcornfactory.com/wcsstore/ThePopcornFactory/images/retro_label.jpg?auto=webp'} alt="Personalize your gift with a message, a pic, or both!" />}
        </div>
    </div>
);

GCIPersonalizationV1.propTypes = {
    classes: object.isRequired,
    gciKey: string,
    gciData: shape({
        key_id: string,
        text: string,
        thumbnail: string,
    }),
    loader: bool,
    featureFlags: object.isRequired,
    setModalState: func,
    editCGCLabelData: func,
    removeGCIData: func,
    loading: bool,
    placementText: string,
    cgcMessageData: string,
    messageData: string,
};

GCIPersonalizationV1.defaultProps = {
    gciKey: '',
    gciData: {
        key_id: '',
        text: '',
        thumbnail: '',
    },
    loader: false,
    setModalState: () => {},
    editCGCLabelData: () => {},
    removeGCIData: () => {},
    loading: false,
    placementText: '',
    cgcMessageData: '',
    messageData: '',
};

export default withStyles(styles)(GCIPersonalizationV1);
